/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */

export enum Easing
{
    Linear,
    Quadratic,
    InvQuadratic
}

export class Tween
{
    public static TweenNumber(from: number, to: number, time: number, easing: Easing): number
    {
        switch (easing)
        {
            case Easing.Linear:     return Tween.TweenNumberLinear(from, to, time);
            case Easing.Quadratic:  return Tween.TweenNumberQuadratic(from, to, time);
            case Easing.InvQuadratic:  return Tween.TweenNumberInvQuadratic(from, to, time);
        }
    }

    public static TweenNumberLinear(from: number, to: number, time: number): number
    {
        return from + ((to - from) * time);
    }

    public static TweenNumberQuadratic(from: number, to: number, time: number): number
    {
        return from + ((to - from) * time * time);
    }

    public static TweenNumberInvQuadratic(from: number, to: number, time: number): number
    {
        let a: number = (1.0 - time);
        let b: number = a * a;
        let c: number = 1.0 - b;
        return from + ((to - from) * c);
    }
}
